import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id });
        localStorage.setItem("ch_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">
      Completing sign-in…
    </div>
  );
}
